import PropTypes from "prop-types"
import React from "react"
import Form from "semantic-ui-react/dist/es/collections/Form/Form"
import Message from "semantic-ui-react/dist/es/collections/Message/Message"
import "./InputField.css"

const InputField = ({ field, label, placeholder, control, ...rest }) => {
  const InputControl = control
  placeholder =
    ((placeholder === undefined || placeholder === null) && label) ||
    placeholder
  return (
    <Form.Field error={!!field.error}>
      {label && <label className="InputField__Label">{label}</label>}
      <InputControl
        placeholder={placeholder}
        {...rest}
        {...field}
        autoComplete="off"
      />
      <Message error content={field.error} />{" "}
      {/* Since we'll be using this under <Form /> Semantic-UI will handle this Message's visibility w.r.t error in <Form /> */}
    </Form.Field>
  )
}

InputField.propTypes = {
  field: PropTypes.object,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  control: PropTypes.func
}

InputField.defaultProps = {
  control: Form.Input
}

export default InputField
